// components/LoginScreen.js
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginScreen.css'; // You'll need to update this CSS file too
import logo from '../assets/logo_white.png'; // Add this to your assets folder
// Assume you have a background image in your assets folder
import backgroundImage from '../assets/Background-Image.jpg';
import AuthService from '../auth/AuthService';
import { AuthContext } from '../auth/AuthContext';

const LoginScreen = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
//  const domain = "";
//  const clientId = "your-app-client-id";
//  const redirectUri = "http://localhost:3000";
//  const responseType = "token"; // or "code" for authorization code flow
//  const identityProvider = "YourIdPName"; // configured in Cognito

  const navigate = useNavigate();
  const authService = new AuthService();
  const { user, loading, refreshSession } = useContext(AuthContext);

  // After auth init / silent refresh, send signed-in users to the app (not only "token string" present)
  useEffect(() => {
    if (!loading && user) {
      navigate('/dashboard', { replace: true });
    }
  }, [loading, user, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (username.trim() === '' || password.trim() === '') {
      setError('Please enter both username and password');
      return;
    }
    
    setIsLoading(true);
    
    try {
      // In a real app, you would validate credentials against a backend
      // Simulating network request with timeout
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Generate a user ID based on username (this would come from backend in a real app)
      const userId = `U-${Math.floor(100 + Math.random() * 900)}`;
      
      localStorage.setItem('userName', username);
      localStorage.setItem('userId', userId);
      
      // Navigate to the dashboard
      navigate('/dashboard');
    } catch (err) {
      showErrorPopup();
    } finally {
      setIsLoading(false);
    }
  };
  

    const handleSSOLogin = async () => {
      try {
        console.log('Starting Azure AD login...');
        
        setIsLoading(true);
        setError('');

        // Renew expired access token via refresh_token when possible (stays on app; no Azure round-trip)
        const restored = await refreshSession();
        if (restored) {
          navigate('/dashboard', { replace: true });
          setIsLoading(false);
          return;
        }

        // No usable session — start interactive OAuth (PKCE)
        localStorage.removeItem('access_token');
        localStorage.removeItem('id_token');
        localStorage.removeItem('refresh_token');

        // Build authorization URL (async due to PKCE generation)
        const url = await authService.buildAuthorizationUrl();
        console.log('Redirecting to Azure AD:', url);
        
        if (!url || url === 'undefined') {
          setError('Azure AD authentication configuration error. Please check console for details.');
          setIsLoading(false);
          return;
        }
        
        // Redirect to Azure AD
        window.location.href = url;
      } catch (error) {
        console.error('Azure AD login error:', error);
        setError('Failed to initiate Azure AD login. Please try again.');
        setIsLoading(false);
      }
    };
  
  const showErrorPopup = () => {
    setError('Invalid Login');
    // In a real implementation, you might want to use a modal dialog component
  };
  
  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  if (loading) {
    return (
      <div className="login-page" style={{ backgroundImage: `url(${backgroundImage})` }}>
        <div className="login-container">
          <div className="login-card">
            <div className="login-content" style={{ padding: '2rem', textAlign: 'center' }}>
              Restoring session…
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="login-container">
        <div className="login-card">
          <div className="login-content">
            <div className="login-options">
              <div className="corporate-login">
                <button
                  className="corporate-button"
                  onClick={handleSSOLogin}
                  disabled={isLoading}
                >
                  {isLoading ? 'LOADING...' : 'Sign in with Microsoft Azure AD'}
                </button>
              </div>
              
              <div className="vertical-divider"></div>
              
              <div className="user-login">
                <div className="login-header">
                  Sign in with your username and password
                </div>
                
                <div className="login-form-container">
                  <input
                    type="text"
                    className="login-input"
                    placeholder="User Id/Name"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                  
                  <div className="password-input-container">
                    <input
                      type={isPasswordVisible ? "text" : "password"}
                      className="login-input"
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <button 
                      type="button" 
                      className="toggle-password"
                      onClick={togglePasswordVisibility}
                    >
                      {isPasswordVisible ? "Hide" : "Show"}
                    </button>
                  </div>
                  
                  <button
                    className="signin-button"
                    onClick={handleLogin}
                    disabled={isLoading}
                  >
                    {isLoading ? "LOADING..." : "SIGN IN"}
                  </button>
                </div>
                
                {error && <div className="error-message">{error}</div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;